module.exports = __webpack_public_path__ + "img/henriette.3d4589f9.png";